/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/categories';

export const CategoryApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findMasterData: async () => {
    const url = `${pathname}/master-data`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  findCategoryStandardProcess: async (id: string) => {
    const url = `${pathname}/standard-process/${id}`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};
